import React from 'react';
import { Alert, Card } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
export const getProductsQuery = gql`
  query products($breweryId: Int!) {
    products(breweryId: $breweryId) {
      id
      name
      lotPrefix
      currentlyBrewingVolume
    }
  }
`;

const ProductsInProgress = ({ history, brewery }) => (
  <Query query={getProductsQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <Alert color="danger">Sorry, there was an error getting the product details</Alert>;
      }

      const { products } = data;
      return (
        <div className="content">
          <Card className="mb4">
            <table className="table mb0">
              <thead>
                <tr>
                  <th className="bt-n bb-n" />
                  <th className="bt-n bb-n">Name</th>
                  <th className="bt-n bb-n">Currently Brewing</th>
                </tr>
              </thead>
              <tbody>
                {products.filter(p => p.currentlyBrewingVolume > 0).map(product => (
                  <tr
                    className="table-row pointer"
                    key={product.id}
                    onClick={() => {
                      history.push(`/products/${product.id}`);
                    }}
                  >
                    <td>
                      <strong className="pl3">{product.lotPrefix}</strong>
                    </td>
                    <td>
                      <strong>{product.name}</strong>
                    </td>
                    <td>{product.currentlyBrewingVolume}L</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(ProductsInProgress));



// WEBPACK FOOTER //
// ./src/containers/productsInProgressCard/productsInProgressCard.jsx